import React, { useState, useEffect } from "react";
import axios from "../requests/axios";
import "./Row.css";
import YouTube from "react-youtube";
import movieTrailer from "movie-trailer";
import AlertDialog from "./Dialog";

const baseUrl = "https://image.tmdb.org/t/p/w400/";

const Row = ({ title, fetchUrl, isRowBig }) => {
  const [movies, setMovies] = useState([]);
  const [trailer, setTrailer] = useState("");
  const [selectMovie, setSelectMovie] = useState(false);
  const [ismovie, setIsmovie] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const requset = await axios.get(fetchUrl);
      setMovies(requset.data.results);
      return requset;
    };

    fetchData();
  }, [fetchUrl]);

  const opts = {
    height: "390",
    width: "100%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };

  const handleClick = (movie) => {
    setIsmovie(movie);

    if (trailer) {
      setTrailer("");
    } else {
      movieTrailer(movie?.name || "", { id: true, multi: true })
        .then((url) => {
          setTrailer(url[0]);
        })
        .catch((error) => setSelectMovie(true));
    }
  };

  return (
    <div className="row">
      <h1 className="row_title">{title}</h1>
      <div className="row__posters">
        {movies.map((movie) => {
          return (
            <img
              onClick={() => handleClick(movie)}
              key={movie.id}
              className={`poster  ${!isRowBig ? "posterDrop" : null}`}
              src={`${baseUrl}${
                isRowBig ? movie.poster_path : movie.backdrop_path
              }`}
              alt={movie.original_name}
            />
          );
        })}
      </div>
      {trailer ? <YouTube videoId={trailer} opts={opts} /> : null}
      {selectMovie && <AlertDialog show={true} movie={ismovie} />}
    </div>
  );
};

export default Row;
